import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Icon } from "../icon";
import { useConfig } from "../_util/config-context";
import { createRocket } from "../_util/create-rocket";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var TagGroup = createRocket("TagGroup", "div.@{prefix}-tag-group");
export var Tag = forwardRefWithStatics(function Tag(_a, ref) {
    var _b;
    var children = _a.children, onClose = _a.onClose, className = _a.className, theme = _a.theme, dark = _a.dark, props = __rest(_a, ["children", "onClose", "className", "theme", "dark"]);
    var hasCloseHandler = typeof onClose === "function";
    var classPrefix = useConfig().classPrefix;
    var classSuffix = dark ? "-dark" : "";
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-tag", className, (_b = {},
            _b[classPrefix + "-tag--unlimited-width"] = true,
            _b[classPrefix + "-tag--edit"] = hasCloseHandler,
            _b["is-blue" + classSuffix] = theme === "primary",
            _b["is-success" + classSuffix] = theme === "success",
            _b["is-warning" + classSuffix] = theme === "warning",
            // @ts-ignore
            _b["is-error" + classSuffix] = theme === "danger" || theme === "error",
            _b)) }, props),
        React.createElement("span", null, children),
        hasCloseHandler && React.createElement(Icon, { link: true, type: "dismiss", onClick: onClose })));
}, {
    Group: TagGroup,
});
Tag.displayName = "Tag";
//# sourceMappingURL=Tag.js.map